<template>
	<div class="main">
		<section class="panel">
			<header class="panel-heading">
				<h2 class="panel-title">外宿請假單</h2>
			</header>
			<div class="panel-body container-fluid">
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">姓&emsp;&emsp;名：</label>
						{{model.name}}
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">學&emsp;&emsp;制：</label>
						{{model.deptSsymStr}}
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">性&emsp;&emsp;別：</label>
						{{model.sexStr}}
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">學&emsp;&emsp;號：</label>
						{{model.account}}
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">科系班級：</label>
						{{model.deptCodeStr}}-{{model.drade}}年{{model.dradeClass}}班
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">身分證字號：</label>
						{{model.idno}}
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4 column-required">聯絡電話：</label>
						<label class="col-xs-8 col-md-8">
							<span v-if="isAdmin('stay')">{{model.tel}}</span>
							<input v-else type="text" name="tel" v-model="model.tel" placeholder="聯絡電話" v-validate="'required|tel'" class="form-control" />
							<span class="text-danger" v-show="errors.has('tel')">{{ errors.first('tel') }}</span>
						</label>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4 column-required">行動電話：</label>
						<label class="col-xs-8 col-md-8">
							<span v-if="isAdmin('stay')">{{model.phone}}</span>
							<input v-else type="text" name="phone" v-model="model.phone" v-validate="'required|phone'" placeholder="行動電話" class="form-control" />
							<span class="text-danger" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
						</label>
					</div>
					<div class="col-md-4 form-group">
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">常用信箱：</label>
						<label class="col-xs-8 col-md-8">
							<span v-if="isAdmin('stay')">{{model.extMail}}</span>
							<input v-else type="email" name="extMail" v-model="model.extMail" placeholder="常用信箱" class="form-control" />
						</label>
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">學校信箱：</label>
						<label class="col-xs-8 col-md-8">
							{{ model.schMail }}
						</label>
					</div>
					<div class="col-md-4 form-group">
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">家長姓名：</label>
						{{ model.parentName }}
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">關　　係：</label>
						{{ model.kinship }}
					</div>
					<div class="col-md-4 form-group">
						<label class="col-xs-4 col-md-4">家長電話：</label>
						{{ model.parentPhone }}
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12">
						<label class="col-xs-4 col-md-1">戶籍地址：</label>
						<div class="col-xs-8 col-md-8">
							{{ model.resiFullAddress }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-8">
						<label class="col-xs-4 col-md-2">通訊地址：</label>
						<div class="col-xs-8 col-md-10">
							{{ model.FullAddress }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4">
						<label class="col-xs-4 col-md-4">寢室名稱(房號)：</label>
						<div class="col-xs-8 col-md-8">
							{{model.bedFloor}}-{{model.bedRoom}}-{{model.bed}}-{{model.bedCategory}}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-4">
						<label class="col-xs-4 col-md-4 column-required">外宿日期：</label>
						<div class="col-xs-8 col-md-8" v-if="isAdmin('stay')">
							{{customFormatter(overnight.overnightDate)}}
						</div>
						<div class="col-xs-8 col-md-8" v-if="sessionData.accountType == 'STU'">
							<datepicker name="overnightDate" :format="customFormatter" v-validate="'required'" :language="zh" :disabled-dates="state.disabledDates" v-model="overnight.overnightDate" input-class="form-control" :style="{width:'auto', display:'inline-block'}">
							</datepicker>
							<span class="text-danger" v-show="errors.has('overnightDate')">{{ errors.first('overnightDate') }}</span>
						</div>
					</div>
					<div class="col-md-4" v-if="sessionData.isRoomMage == `Y` || isAdmin(`stay`)">
						<label class="col-xs-4 col-md-4 column-required">代理人：</label>
						<div class="col-xs-8 col-md-8" v-if="isAdmin('stay')">
							{{model.deputyName}}
						</div>
						<div class="col-xs-8 col-md-8" v-if="sessionData.accountType == 'STU'">
							<select name="deputy" v-model="overnight.deputy" class="form-control" v-validate="(sessionData.isRoomMage == `Y` || isAdmin(`stay`)) ? 'required' : ''">
								<option value="">--請選擇--</option>
								<option v-for="(x, i) in mages" :key="i" :value="x.account">{{x.name}}</option>
							</select>
              <span class="text-danger" v-show="errors.has('deputy')">{{ errors.first('deputy') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12">
						<label class="col-xs-4 col-md-2 column-required">申請外宿原因：</label>
						<div class="col-xs-8 col-md-10" v-if="isAdmin('stay')">
							{{overnight.overnightReason}}
						</div>
						<div class="col-md-10" style="padding-left: 0 !important;" v-if="sessionData.accountType == 'STU'">
							<textarea class="form-control" style="width: 100%" rows="5" name="overnightReason" v-model="overnight.overnightReason" v-validate="'required'" maxlength="100"></textarea>
							<span class="text-danger" v-show="errors.has('overnightReason')">{{ errors.first('overnightReason') }}</span>
						</div>
					</div>
				</div>
				<div class="row form-group" v-if="isAdmin('stay')">
					<div class="col-md-12 form-group" >
						<label class="col-xs-3 col-md-2 column-required form-group">審核狀態：</label>
						<div class="col-xs-9 col-md-10 form-group">
							<label for="applyStatus_A" class="radio-inline">
								<input id="applyStatus_A" name="applyStatus" type="radio" value="A" v-model="overnight.applyStatus" />待審核
							</label>
							<label for="applyStatus_Y" class="radio-inline">
								<input id="applyStatus_Y" name="applyStatus" type="radio" value="Y" v-model="overnight.applyStatus" />審核通過
							</label>
							<label for="applyStatus_N" class="radio-inline">
								<input id="applyStatus_N" name="applyStatus" type="radio" value="N" v-model="overnight.applyStatus" />審核不通過
							</label>
                            <label for="applyStatus_R" class="radio-inline">
								<input id="applyStatus_R" name="applyStatus" type="radio" value="R" v-model="overnight.applyStatus" />退回
							</label>
						</div>
					</div>
                    <div class="col-md-12 form-group" v-if="overnight.applyStatus == `N` || overnight.applyStatus == `R`">
                        <textarea class="form-control" rows="5" name="reviewOpinion" v-model="overnight.reviewOpinion" maxlength="1000"></textarea>
                    </div>
				</div>
                <div class="row form-group" v-else-if="overnight.applyStatus">
                    <div class="col-md-12 form-group" >
						<label class="col-xs-3 col-md-2 column-required form-group">審核狀態：</label>
						<div class="col-xs-9 col-md-10 form-group">
							{{overnight.applyStatus == `A` ? "待審核":(overnight.applyStatus == `Y` ? "審核通過": (overnight.applyStatus == `N` ? "審核不通過" : (overnight.applyStatus == `R`? "退回":"")))}}
						</div>
					</div>
                    <div class="col-md-12 form-group">
                        {{overnight.reviewOpinion}}
                    </div>
                </div>
				<div class="row form-group">
					<div class="col-md-2 form-group col-md-offset-4">
						<a @click="clickPrevious" class="btn s_btn_g btn-block">返回</a>
					</div>
					<div class="col-md-2 form-group" v-if="sessionData.accountType == 'STU' && (model.applyStatus =='R' || !model.applyStatus)">
						<a @click="handleSave" class="btn btn-primary btn-block" >儲存</a>
					</div>
					<div class="col-md-2 form-group" v-if="isAdmin('stay')">
						<a @click="checkApply" class="btn btn-primary btn-block" >儲存</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
export default {
	data(){
		return{
			model:{},
			overnight:{
				sno:null,
				applyId:"",
				account:"",
				overnightDate:null,
				overnightReason:"",
				applyStatus:"",
                reviewOpinion:"",
				deputy:"",
			},
			mages:[],
			storeData:{},
			state:{
				disabledDates:{
					to:this.toDate()
				}
			}
		}
	},
	methods:{
		applyInit(){
            const ApiFunc = async ()=>{
                const api = "/api/RoomOvernight/overnightApplyInit/";
                return await this.$axios.post(api, this.overnight);
            }
            Promise.resolve(ApiFunc()).then(resp => {
                if(resp.data.status == "success"){
                    this.model = resp.data.data;
                    this.overnight = {
                        sno:this.model.sno,
                        applyId:this.model.applyId,
                        account:this.model.account,
                        overnightDate:this.model.overnightDate,
                        overnightReason:this.model.overnightReason,
                        applyStatus:this.model.applyStatus,
                        reviewOpinion:this.model.reviewOpinion,
						deputy:this.model.deputy,
                    }
					this.mages = resp.data.mages;
                }else{
                    const _this = this;
                    bootbox.alert(resp.data.msg, ()=>{
                        _this.clickPrevious();
                    });

                }
            });
		},
		clickPrevious() {
			this.$router.go(-1)
		},
		handleSave(){
			this.$validator.validateAll().then(result =>{
				if(result){
					this.overnight.idno = this.model.idno;
					this.overnight.account = this.model.account;
					this.overnight.smtr = this.model.smtr;
					this.overnight.dormitoryType = this.model.dormitoryType;
					this.overnight.applyStatus = "A";
                    this.overnight.reviewOpinion = "";
					this.overnight.applyId = this.model.applyId;
					let requestOvernight = {};
					for(let k in this.overnight){
						if(this.overnight[k]){
							if(k == "overnightDate"){
								requestOvernight[k] = this.customFormatter(this.overnight[k]);
							}else{
								requestOvernight[k] = this.overnight[k];
							}
						}
					}

					const api = "/api/RoomOvernight/saveOvernightApply/";
					let _this = this;
					this.$axios.post(api, requestOvernight).then(resp => {
						if(resp.data.status == "success"){
							_this.clickPrevious()
						}else{
							bootbox.alert(resp.data.msg);
						}
					});
				}
			});
		},
		checkApply() {
			let _this = this;
			const api = "/api/RoomOvernight/checkApply";
			let data = {};
            if(this.overnight.applyStatus == "Y"){
                this.overnight.reviewOpinion = "";
            }
			for(let k in this.overnight){
				if(this.overnight[k]){
					data[k] = this.overnight[k];
				}
			}
			this.$axios.post(api, JSON.stringify(data)).then(resp => {
				bootbox.alert(resp.data.msg, ()=>{
					if (resp.data.status == "success") {
						_this.clickPrevious()
					}
				});

			});
		},
		toDate(){
			let date = this.nowDate();
			date.setDate(date.getDate() - 1);
			return date;
		}
	},
	mounted(){
		if (this.getStore(this.$route.name) != null) {
			this.storeData = JSON.parse(this.getStore(this.$route.name));
			this.overnight.account = this.storeData.account;
			this.overnight.sno = this.storeData.sno;
			this.overnight.applyId = this.storeData.applyId;
		}else{
			if(this.sessionData.accountType == "STU"){
				this.overnight.account = this.sessionData.account;
			}
		}
		this.applyInit();
	},
	beforeRouteLeave(to, from, next) {
		this.removeStore(this.$route.name);
		next();
	}
}
</script>
